import { Card, DisplayProperties } from '@com-delta-idp/mnx-skymiles-shared';

export interface Offers extends DisplayProperties {
  cards: Card[];
}
